import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import UserHeader from '../components/Headers/UserHeader';
import Header from '../components_v2/Headers/Header';
import { isLogin, getPrivileges } from '../functions/Auth';
import MapContext from '../context/MapContext'
export const ProtectedRoute = ({ component: Component,  ...rest }) => {
    const {versionNum}=useContext(MapContext)
    React.useEffect(
        () => { }, []);
    return (
        <>
        {
            versionNum === 1 ?
            <UserHeader />
            :
            <Header />
        }
            <Route {...rest} render={(props) => {
                if (isLogin()) {
                    if (props.location.pathname !== "/UsersDashboard") {                        
                        if (getPrivileges().includes(1)) {
                            return <Component {...props} />
                        } else if(getPrivileges().includes(2) && (props.location.pathname == "/import_data" || props.location.pathname == "/file-import-requirements-and-best-practices")) {
                            return <Component {...props} />
                        } else if(getPrivileges().length !== 0 && (props.location.pathname == "/midblock_details" || props.location.pathname == "/intersection_details")) {
                            return <Component {...props} />
                        } else {
                            return <Redirect to={{
                                pathname: "/UsersDashboard"                                    
                            }} />
                        }
                    } else {
                        return <Component {...props} />
                    }
                } else {
                    return <Redirect to={{
                        pathname: "/"                                    
                    }} />
                }
            }
            }></Route>
        </>
    )
}